export default __webpack_public_path__ + "media/images/nowprinting-b9d88938370dbeeb4ecf96487efee2a0.png";